var _rect, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 141,
    viewBox: "0 0 265 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.2917,
    y: 2.63922,
    width: 137.361,
    height: 136,
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.652 70.6392C169.652 108.176 138.921 138.639 100.972 138.639C63.0227 138.639 32.2917 108.176 32.2917 70.6392C32.2917 33.1021 63.0227 2.63922 100.972 2.63922C138.921 2.63922 169.652 33.1021 169.652 70.6392Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 71.6392,
    x2: 60.5832,
    y2: 71.6392,
    stroke: "#2B9870",
    strokeWidth: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 191.976,
    y2: -2,
    transform: "matrix(-0.710391 0.703807 -0.710645 -0.70355 168.09 0.639221)",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActKey);
export default __webpack_public_path__ + "static/media/act_key.eda5c90da7aa8315823a30e1136659b8.svg";
export { ForwardRef as ReactComponent };